<script lang="ts">
	import { makeComponentClassList } from "../utils";
	import DefaultLoading from "../SVG/DefaultLoading.svelte";

	export let noPadding = false;
	export let loading = false;

	$: classVariables = makeComponentClassList($$props);

</script>

<div class={'card' + classVariables} class:noPadding>
	{#if loading}
		<div class="loading">
			<DefaultLoading />
		</div>
	{/if}
	<slot />
</div>

<style lang="scss">
	@import "../variables.scss";

	.card {
		display: flex;
		width: 100%;
		height: 100%;
		background-color: white;
		border-radius: 5px;
		box-sizing: border-box;
		padding: 20px 10px;
		position: relative;

		.loading {
			width: 30px;
			height: 30px;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			display: flex;
			justify-content: center;
			align-items: center;
		}

		&.noPadding {
			padding: 0;
		}
	}

	@include DesktopSize {
		.card {
			padding: 30px;
		}
	}

</style>
